import Vue from 'vue'

//引入ElementUI
import ElementUI from 'element-ui'
//引入element-ui的css文件
import 'element-ui/lib/theme-chalk/index.css'
Vue.use(ElementUI)


//引入自定义的全局css文件
import '@/assets/css/index.css'


import Fragment from 'vue-fragment'
Vue.use(Fragment.Plugin)

//md5 有用到
import md5 from 'js-md5'
Vue.prototype.$md5 = md5


//将菜单化成树 有用到
import toTree from '@/utils/toTree'
Vue.prototype.$toTree = toTree


//loading 有用到
import loading from '@/utils/loading'
Vue.prototype.$loading = loading

//message 有用到
import message from "@/utils/message";
Vue.prototype.$message = message


//axios
import axios from '@/utils/axios'
Vue.prototype.$axios = axios

import '@/utils/router'

import url from '@/utils/url'
//定义前端url前缀
Vue.prototype.feUrl = url.feUrl
//定义后端url前缀
Vue.prototype.reUrl = url.reUrl
